var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticStyle:{"height":"400px","width":"100%"},attrs:{"id":"equip-statistic-pie"}})}
var staticRenderFns = []

export { render, staticRenderFns }